import React from 'react';

import { connect } from 'react-redux';

import { LegacyAnalyticsInterface } from '@nerdwallet/calculator-onboarding-modal';
import { Tooltip, Text, Box } from '@nerdwallet/currency';
import { NumStepper } from '@nerdwallet/react-stepper';

import { ENTITY_NAME, RENT_VS_BUY } from '../../../../lib/analytics-constants';
import {
  RentVsBuyInput,
  formatMonths,
  inputOnChange,
  INPUT_TRACKING_TYPES,
  BedrockInterface,
} from '../../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

type onInputChange = OnChangeEvent | number;

const RentSecurityDepositInput: React.FC<RentVsBuyInput> = ({
  value,
  dispatch,
  analytics,
  label,
  tooltip,
  className,
}) => {
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: onInputChange) => {
    let legacy: LegacyAnalyticsInterface;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        inputType: INPUT_TRACKING_TYPES.RANGE,
      };
    }

    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'rentSecurityDeposit',
      calculator: RENT_VS_BUY,
      inputType: 'number',
    });
  };

  return (
    <Box>
      <Text size="small">
        {label}
        <Tooltip
          placement="top"
          content={tooltip}
          analytics={{
            entityName: ENTITY_NAME.HELP_BUBBLE_INTERACTED,
            eventType: ENTITY_NAME.HELP_BUBBLE_INTERACTED,
            payload: {
              additional_attributes: {
                help_button_location: 'rentSecurityDeposit',
              },
            },
          }}
        />
      </Text>
      <Box className={className}>
        <NumStepper
          editable
          formatter={formatMonths}
          max={30}
          min={1}
          stepSize={1}
          value={value}
          onChange={onInputChange}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  value: state?.rentvsbuyCalculator?.inputs?.rentSecurityDeposit,
});

export default connect(mapStateToProps)(RentSecurityDepositInput);
